var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',_vm._b({attrs:{"icon":_vm.name,"width":_vm.width,"height":_vm.height}},'Icon',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }